import { createFileRoute } from '@tanstack/react-router'
import GovernanceSettings from '@/pages/settings/governance'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/governance',
)({
  component: GovernanceSettings,
})
